import { Bike } from './../bus/types';
import { Bus } from 'src/store/events/types';
import { CardEvent, Station } from './../events/types';
import axios, { AxiosResponse } from 'axios';
import { action } from 'typesafe-actions';
import { apiUrl } from './../../index';
import { alertError, alertSuccess } from './../alert/actions';
import { Participant, ParticipantActionTypes, RegisterParticipant, Participation } from './types';
import { EventActionTypes } from '../events/types';

// export const getEventsbyWeek = (week: Week) => {
//   const fetchRequest = () => action(EventActionTypes.FETCH_REQUEST);
//   const fetchSuccess = (data: CardEvent[], weekId: number) =>
//     action(EventActionTypes.FETCH_SUCCESS, { data, weekId });
//   const fetchError = (error: Error) => action(EventActionTypes.FETCH_ERROR, error);

//   interface Response {
//     events: CardEvent[];
//   }

//   return (dispatch: any) => {
//     dispatch(fetchRequest());

//     console.log(
//       'GETTING EVENTS FROM ',
//       moment(week.startDate).toString(),
//       ' - ',
//       moment(week.endDate).toString()
//     );

//     axios
//       .get(apiUrl + '/events/', {
//         params: {
//           from: moment(week.startDate).toString(),
//           to: moment(week.endDate).toString()
//         }
//       })
//       .then((res: AxiosResponse<Response>) => {
//         console.log('GOT EVENTS ', res.data.events.length);
//         dispatch(fetchSuccess(res.data.events, week.id));
//       })
//       .catch(err => {
//         dispatch(fetchError(err));
//         dispatch(alertError(err));
//       });
//   };
// };

export const registerParticipant = (participantData: RegisterParticipant) => {
  const fetchRequest = () => action(ParticipantActionTypes.REGISTER_REQUEST);
  const fetchSuccess = (data: Participant) =>
    action(ParticipantActionTypes.REGISTER_SUCCESS, { data });
  const fetchError = (error: Error) => action(ParticipantActionTypes.REGISTER_ERROR, error);

  interface Response {
    participant: Participant;
    cardevent: CardEvent;
    station?: Station;
    bus?: Bus;
    bike?: Bike;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .post(apiUrl + '/participant/register', participantData)
      .then((res: AxiosResponse<Response>) => {
        console.log(res.data);
        dispatch(fetchSuccess(res.data.participant));
        dispatch(action(EventActionTypes.FETCH_SINGLE_SUCCESS, res.data.cardevent));
        dispatch(alertSuccess('Teilnehmer hinzugefügt!'));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const deleteParticipant = (partId: number) => {
  const fetchRequest = () => action(ParticipantActionTypes.REQUEST);
  const fetchSuccess = () => action(ParticipantActionTypes.DELETE_SUCCESS);
  const fetchError = (error: Error) => action(ParticipantActionTypes.ERROR, error);

  interface Response {
    cardevent: CardEvent;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .delete(`${apiUrl}/participant/${partId}`)
      .then((res: AxiosResponse<Response>) => {
        console.log(res.data);
        dispatch(fetchSuccess());
        dispatch(action(EventActionTypes.FETCH_SINGLE_SUCCESS, res.data.cardevent));
        dispatch(alertSuccess('Teilnehmer gelöscht!'));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const updateParticipant = (participation: Participation) => {
  const fetchRequest = () => action(ParticipantActionTypes.REQUEST);
  const fetchSuccess = () => action(ParticipantActionTypes.UPDATE_SUCCESS);
  const fetchError = (error: Error) => action(ParticipantActionTypes.ERROR, error);

  interface Response {
    cardevent: CardEvent;
  }

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .put(`${apiUrl}/participant/`, { participation })
      .then((res: AxiosResponse<Response>) => {
        console.log(res.data);
        dispatch(fetchSuccess());
        dispatch(action(EventActionTypes.FETCH_SINGLE_SUCCESS, res.data.cardevent));
        dispatch(alertSuccess('Bearbeitung gespeichert!'));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/participant/actions.ts